import { updateObject } from '../../components/cdl-react-components/utilities'
import { 
    REMOVE_USER, 
    SET_CONFIGURATION,
    SET_FRONT_PAGE,
    SET_USER,
    UPDATE_EDITIONS,
    UPDATE_SHOW_TOOLTIP,
    PUSH_NOTIFICATION,
    POP_NOTIFICATION
} from '../actions/types'
import { CONTENT_MODE } from '../../utilities/constants'

const dataReducer = (state = {
    configuration: {
        contentMode: CONTENT_MODE.DESKTOP
    },
    searchId: 0,
    notifications: [],
    authenticated: false
}, action) => {
    const stateUpdates = () => {
        switch (action.type) {
            case SET_CONFIGURATION: return { configuration: { ...state.configuration, ...action.payload } }
            case SET_FRONT_PAGE: return { frontPage: action.payload }
            case SET_USER: return { ...action.payload }
            case REMOVE_USER: return { user: undefined, authenticated: false }
            case UPDATE_EDITIONS: return { editions: action.payload }
            case UPDATE_SHOW_TOOLTIP: return { showTooltip: action.payload }
            case PUSH_NOTIFICATION: return { notifications: [...state.notifications, action.payload] }
            case POP_NOTIFICATION: return { notifications: state.notifications.length > 0 ? state.notifications.slice(1) : state.notifications }
            default: return {}
        }
    }

    return updateObject(state, stateUpdates())
}

export default dataReducer